export type AdvertisementDisplayPosition = 'top' | 'invoice'

export const advertisementKeyFactory = {
  all: [{ scope: 'advertisement' }] as const,
  advertisements: (displayPosition: AdvertisementDisplayPosition = 'top') =>
    [
      {
        ...advertisementKeyFactory.all[0],
        entity: 'advertisements',
        displayPosition,
      },
    ] as const,
}
